"use strict";

var _interopRequireDefault = require("/home/sitc1119/.jenkins/workspace/sitceb-booking-ui-prod/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es6.function.name");
require("core-js/modules/web.dom.iterable");
var _regeneratorRuntime2 = _interopRequireDefault(require("/home/sitc1119/.jenkins/workspace/sitceb-booking-ui-prod/node_modules/@babel/runtime-corejs2/helpers/regeneratorRuntime.js"));
require("regenerator-runtime/runtime");
var _asyncToGenerator2 = _interopRequireDefault(require("/home/sitc1119/.jenkins/workspace/sitceb-booking-ui-prod/node_modules/@babel/runtime-corejs2/helpers/asyncToGenerator.js"));
var _objectSpread2 = _interopRequireDefault(require("/home/sitc1119/.jenkins/workspace/sitceb-booking-ui-prod/node_modules/@babel/runtime-corejs2/helpers/objectSpread2.js"));
var _Pagination = _interopRequireDefault(require("@/components/Pagination"));
var _vuex = require("vuex");
var _booking = require("@/api/bookSpace/booking");
var _DragDialog = _interopRequireDefault(require("@/components/DragDialog"));
var _validateContainerNoDialog = _interopRequireDefault(require("./validateContainerNoDialog"));
var _utils = require("@/utils");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: "",
  components: {
    dragDialog: _DragDialog.default,
    Pagination: _Pagination.default,
    validateContainerNoDialog: _validateContainerNoDialog.default
  },
  props: {
    id: {
      type: String,
      default: ''
    },
    disabledType: {
      type: Boolean,
      default: false
    },
    bookingHeadWebId: {
      type: String,
      default: ''
    }
  },
  data: function data() {
    return {
      fileList: [],
      validateContainerNoMsg: '',
      validateContainerNoVisible: false,
      validateContainerNoFlag: true
    };
  },
  computed: (0, _objectSpread2.default)({}, (0, _vuex.mapGetters)(['language', 'userInfo'])),
  created: function created() {},
  mounted: function mounted() {},
  methods: {
    uploadFile: function () {
      var _uploadFile = (0, _asyncToGenerator2.default)( /*#__PURE__*/(0, _regeneratorRuntime2.default)().mark(function _callee(item) {
        var _this = this;
        var formDatas, files, checkValidateContainerNoFlag;
        return (0, _regeneratorRuntime2.default)().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              this.loading = (0, _utils.load)();
              formDatas = new FormData();
              formDatas.append("file", item.file);
              files = this.$refs.upload.uploadFiles;
              _context.next = 6;
              return this.checkValidateContainerNo(formDatas);
            case 6:
              checkValidateContainerNoFlag = _context.sent;
              if (checkValidateContainerNoFlag) {
                this.$refs.upload.uploadFiles = files;
                this.loading.close();
              } else {
                (0, _booking.excelImport2)(formDatas).then(function (res) {
                  if (res.success) {
                    if (res.data) {
                      _this.$message.warning(res.data);
                    } else {
                      _this.$message.success(_this.$t("com.importSuccess"));
                    }
                    _this.$parent.handleSearch();
                    _this.$parent.vgmImportDialogVisible = false;
                  } else {
                    _this.$message.warning(res.errorMessages[0]);
                  }
                }).finally(function () {
                  _this.loading.close();
                  _this.validateContainerNoFlag = true;
                  _this.fileList = [];
                  _this.$refs.upload.clearFiles();
                });
              }
            case 8:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
      function uploadFile(_x) {
        return _uploadFile.apply(this, arguments);
      }
      return uploadFile;
    }(),
    checkValidateContainerNo: function () {
      var _checkValidateContainerNo = (0, _asyncToGenerator2.default)( /*#__PURE__*/(0, _regeneratorRuntime2.default)().mark(function _callee2(item) {
        var res;
        return (0, _regeneratorRuntime2.default)().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              this.loading = (0, _utils.load)();
              if (!(item && this.validateContainerNoFlag)) {
                _context2.next = 18;
                break;
              }
              _context2.next = 4;
              return (0, _booking.vgmImportvalidateContainerNo)(item);
            case 4:
              res = _context2.sent;
              if (!res.success) {
                _context2.next = 16;
                break;
              }
              if (!res.data) {
                _context2.next = 14;
                break;
              }
              this.validateContainerNoMsg = res.data;
              this.validateContainerNoVisible = true;
              this.validateContainerNoFlag = true;
              this.loading.close();
              return _context2.abrupt("return", true);
            case 14:
              this.loading.close();
              return _context2.abrupt("return", false);
            case 16:
              _context2.next = 20;
              break;
            case 18:
              this.loading.close();
              return _context2.abrupt("return", false);
            case 20:
            case "end":
              return _context2.stop();
          }
        }, _callee2, this);
      }));
      function checkValidateContainerNo(_x2) {
        return _checkValidateContainerNo.apply(this, arguments);
      }
      return checkValidateContainerNo;
    }(),
    beforeAvatarUpload: function beforeAvatarUpload(file) {
      var isLt2M = file.size / 1024 / 1024 < 10;
      if (!isLt2M) {
        this.$message.error('上传文件大小不能超过 10MB!');
      }
      this.fileList.push(file);
      return isLt2M;
    },
    handleUploadFile: function handleUploadFile() {
      if (this.$refs.upload.uploadFiles.length === 0) {
        return this.$message.warning(this.$t("home.selectFileWaring"));
      }
      this.$refs.upload.uploadFiles.forEach(function (item) {
        item.status = "ready";
      });
      this.$refs.upload.submit();
    },
    handleRemove: function handleRemove(file, fileList) {
      console.log(file, fileList);
    },
    handlePreview: function handlePreview(file) {
      console.log(file);
    },
    handleExceed: function handleExceed(files, fileList) {
      this.$message.warning("\u5F53\u524D\u9650\u5236\u9009\u62E9 3 \u4E2A\u6587\u4EF6\uFF0C\u672C\u6B21\u9009\u62E9\u4E86 ".concat(files.length, " \u4E2A\u6587\u4EF6\uFF0C\u5171\u9009\u62E9\u4E86 ").concat(files.length + fileList.length, " \u4E2A\u6587\u4EF6"));
    },
    beforeRemove: function beforeRemove(file, fileList) {
      return this.$confirm("\u786E\u5B9A\u79FB\u9664 ".concat(file.name, "\uFF1F"));
    },
    opened: function opened() {
      //   this.handleSearch()
    },
    handleDownloadExcel: function handleDownloadExcel() {
      var link = document.createElement('a');
      link.href = '/static/excel/Container&VGM_Import_Format.xls'; // 指向你的 Word 文档路径
      link.download = 'Container&VGM_Import_Format.xls'; // 设置下载文件名
      link.click(); // 触发点击事件
    }
  }
};